<mat-form-field [formGroup]="group" [appearance]="appearance">
  <mat-label>{{field.localeText?.name}}</mat-label>
  <input matInput [min]="min" [max]="max" [required]="field.required"
         [matDatepicker]="picker" [(ngModel)]="value"  [formControlName]="field.fieldKey">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker disabled="false" [startView]="startView" [startAt]="value ? value : initialDate" ></mat-datepicker>
  <ng-container *ngFor="let validation of field.validation;" ngProjectAs="mat-error">
    <mat-error *ngIf="group.get(field.fieldKey).hasError(validation.name)">
      {{validation.message}}
    </mat-error>
  </ng-container>
</mat-form-field>
